import styled from "styled-components";

export const Row = styled.div`
  display: grid;
  grid-template-columns: ${p =>
    p.gtc ? p.gtc : p.cols ? `repeat(${p.cols}, 1fr)` : "1fr"};
  grid-gap: 0.5rem;
  margin: ${p => p.margin};
  @media (max-width: 667px) {
    grid-template-columns: 1fr;
  }
`;
